import { useWeb3React } from '@web3-react/core'
import { SupportedChainId } from 'constants/chains'
import styled from 'styled-components/macro'
import { MEDIA_WIDTHS } from 'theme'

import { useActivePopups, useRemovePopup } from '../../state/application/hooks'
import { useURLWarningVisible } from '../../state/user/hooks'
import { AutoColumn } from '../Column'
import ClaimPopup from './ClaimPopup'
import PopupItem from './PopupItem'

const MobilePopupWrapper = styled.div`
  position: fixed;
  top: 72px;
  left: 0;
  right: 0;
  display: none;
  z-index: 3;

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToSmall`
    display: flex;
    justify-content: center;
    padding: 0 12px;
  `};
`

const MobilePopupStack = styled.div`
  display: flex;
  gap: 14px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 0 4px;
  pointer-events: auto;

  ::-webkit-scrollbar {
    display: none;
  }

  > * {
    flex: 0 0 260px;
    max-width: 280px;
  }
`

const MobileCloseAll = styled.button`
  align-self: center;
  padding: 6px 14px;
  border-radius: 20px;
  border: none;
  background: ${({ theme }) => theme.backgroundInteractive};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 12px;
  font-weight: 600;
  pointer-events: auto;
  flex: 0 0 auto;
  min-width: auto;
`

const StopOverflowQuery = `@media screen and (min-width: ${MEDIA_WIDTHS.deprecated_upToMedium + 1}px) and (max-width: ${
  MEDIA_WIDTHS.deprecated_upToMedium + 500
}px)`

const FixedPopupColumn = styled(AutoColumn)<{ extraPadding: boolean; xlPadding: boolean }>`
  position: fixed;
  top: ${({ extraPadding }) => (extraPadding ? '72px' : '64px')};
  right: 1rem;
  max-width: 280px !important;
  width: 100%;
  z-index: 3;

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToSmall`
    display: none;
  `};

  ${StopOverflowQuery} {
    top: ${({ extraPadding, xlPadding }) => (xlPadding ? '72px' : extraPadding ? '72px' : '64px')};
  }
`

export default function Popups() {
  // get all popups
  const activePopups = useActivePopups()
  const removePopup = useRemovePopup()

  const urlWarningActive = useURLWarningVisible()

  // need extra padding if network is not L1 Ethereum
  const { chainId } = useWeb3React()
  const isNotOnMainnet = Boolean(chainId && chainId !== SupportedChainId.MAINNET)

  return (
    <>
      <FixedPopupColumn gap="10px" extraPadding={urlWarningActive} xlPadding={isNotOnMainnet}>
        <ClaimPopup />
        {activePopups.map((item) => (
          <PopupItem key={item.key} content={item.content} popKey={item.key} removeAfterMs={item.removeAfterMs} />
        ))}
        {activePopups.length > 1 && (
          <MobileCloseAll
            style={{ alignSelf: 'flex-end' }}
            onClick={() => {
              activePopups.forEach(({ key }) => removePopup(key))
            }}
          >
            Close all
          </MobileCloseAll>
        )}
      </FixedPopupColumn>
      {activePopups?.length > 0 && (
        <MobilePopupWrapper>
          <MobilePopupStack>
            {activePopups
              .slice(0)
              .reverse()
              .map((item) => (
                <PopupItem key={item.key} content={item.content} popKey={item.key} removeAfterMs={item.removeAfterMs} />
              ))}
            {activePopups.length > 1 && (
              <MobileCloseAll
                onClick={() => {
                  activePopups.forEach(({ key }) => removePopup(key))
                }}
              >
                Close all
              </MobileCloseAll>
            )}
          </MobilePopupStack>
        </MobilePopupWrapper>
      )}
    </>
  )
}
